import { Form as FormInitial, Row, Col, Space, Tooltip, Checkbox, message } from 'antd';
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  ModalItem,
  ButtonItem,
  FormItem,
  InputItem,
  Form,
  ErrorItem
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ordenCompraPdf from "../../../../Pdf/ordenCompraPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class MandarCorreoOrdenDeCompra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pdf: null,
      // null = todavía no se sabe (no se ha consultado). Se bloquea la descarga
      // hasta tener la respuesta de datosPdf.
      aprobada: null,
    };
    this.formRef = React.createRef();

    this.cerrarMandarCorreoOrdenDeCompra = this.cerrarMandarCorreoOrdenDeCompra.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        // Se limpia el dato de la orden anterior: el modal se reusa para varias.
        this.setState({ aprobada: null });
        this.consultarTodo();
      }
    }
  }


  async consultarTodo() {
    this.setState({ loading: true });
    // El modal se reusa para varias ordenes y solo se limpiaba al enviar con exito.
    // Como ahora los correos se precargan y se le aprenden al proveedor, arrastrar los
    // de la orden anterior terminaria guardandolos en el proveedor equivocado.
    this.formRef.current?.resetFields();
    try {
      const res = await axios.post(
        "ordenesdecompra/datosPdf",
        { ordenId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );

      const pdf = pdfMake.createPdf(ordenCompraPdf(res.data));

      // Los correos que ya conoce el proveedor y las copias configuradas por la empresa
      // vienen en la misma respuesta. Solo se precargan si traen algo: si no, se respeta
      // el initialValue de cada lista.
      if (res.data?.correosEnvio?.length > 0) {
        this.formRef.current?.setFieldsValue({ correosEnvio: res.data.correosEnvio });
      }
      if (res.data?.correosCopiaOrdenCompra?.length > 0) {
        this.formRef.current?.setFieldsValue({ correosCopia: res.data.correosCopiaOrdenCompra });
      }

      this.setState(
        {
          loading: false,
          pdf: pdf,
          // `aprobada` ausente = orden vieja, cuenta como aprobada.
          aprobada: res.data?.aprobada !== false,
        },
        () => {
          pdf.open({}, window.frames["OrdenCompraPdf"]);
        }
      );
    } catch (error) {
      console.error("Error al consultar los datos:", error);
      this.setState({ loading: false });
    }
  }

  /**
   * Una orden sin aprobar solo la puede bajar quien tiene el permiso de aprobar
   * (es quien la va a revisar). Mientras no se sabe (`aprobada: null`), se
   * bloquea.
   */
  puedeDescargar() {
    return this.props.permisoAprobarOrdenDeCompra || this.state.aprobada === true;
  }

  async descargarOrdenDeCompra(value) {
    if (!this.puedeDescargar()) {
      return message.warn("La orden de compra aun no esta aprobada");
    }

    try {
      const res = await axios.post(
        "ordenesdecompra/datosPdf",
        { ordenId: this.props.id, empresaId: this.props.empresaId, descarga: true },
        { headers: this.props.headersToken }
      );

      const numero = (res.data?.respuestaFactura?.dataSat?.Serie || '') + '_' + (res.data?.respuestaFactura?.dataSat?.Folio || '')

      pdfMake.createPdf(ordenCompraPdf(res.data)).download(`Orden_De_Compra_${numero}.pdf`);

    } catch (error) {
      console.error("Error al consultar los datos:", error);
      this.setState({ loading: false });
    }
  }

  cerrarMandarCorreoOrdenDeCompra() {
    this.props.cerrarMandarCorreoOrdenDeCompra();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (values?.correosEnvio?.length > 0) {
      this.setState({ loading: true });
      axios
        .post(
          "ordenesdecompra/enviarOrden",
          { ...values, ordenId: this.props.id, empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Orden de compra enviado");
            this.formRef.current.resetFields();
            this.cerrarMandarCorreoOrdenDeCompra();
          } else if (res.data.success === 1) {
            message.error("No se pudo enviar la orden de compra a ese correo");
          } else {
            message.error("Sucedió un error y no se pudo enviar");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al enviar el correo");
          console.error("Error:", error);
        });
    } else {
      message.info('Proporcione al menos un correo de envío');
    }
  }


  render() {
    const puedeDescargar = this.puedeDescargar();

    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarMandarCorreoOrdenDeCompra}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreo"
          layout
          width={700}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: '' }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>

          {/*
            El CC es opcional, por eso arranca sin renglones: una fila vacia con
            `required` + `email` bloquearia el envio de toda orden que no lleve copia.
          */}
          <FormInitial.List name="correosCopia" initialValue={[]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Con copia"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo en copia (CC)" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      blanco={true}
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      lessTime
                    >
                      Agregar copia (CC)
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>

          <FormItem
            name="guardarCorreosCopia"
            label="Guardar copias"
            margin
            valuePropName="checked"
            initialValue={false}
            tooltip="Los correos en copia quedan guardados para todas las ordenes de compra de la empresa. Si se deja la lista vacia y se marca esta casilla, se borran los que estaban guardados."
          >
            <Checkbox>Guardar estos correos en copia para siguientes envíos</Checkbox>
          </FormItem>

          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <Tooltip
                title={puedeDescargar ? "Descargar" : "La orden aun no esta aprobada"}
              >
                <ButtonItem
                  icon={<DownloadOutlined />}
                  blanco={true}
                  disabled={!puedeDescargar}
                  onClick={() => this.descargarOrdenDeCompra()}
                >
                  Descargar
                </ButtonItem>
              </Tooltip>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarMandarCorreoOrdenDeCompra} // Removido el bind aquí ya que fue enlazado en el constructor
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>

        <iframe
          title={"Orden de Compra"}
          style={{ width: "100%", height: "100vh" }}
          id="OrdenCompraPdf"
          name="OrdenCompraPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAprobarOrdenDeCompra:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a13c3f22a586012f040fe34"
      )?.activado,
  };
};

export default connect(mapStateToProps)(MandarCorreoOrdenDeCompra);
